import _invoke from 'lodash/invoke';

export default new (class NewrelicEngine {
  /**
   *
   * @param {Object|String} error Can be an Error object or the reason property of PromiseRejectionEvent interface.
   * @param {*} customAttributes Optional. An object containing name/value pairs representing custom attributes.
   */
  sendError(error, customAttributes = {}) {
    _invoke(window, 'newrelic.noticeError', error, customAttributes);
  }
})();
